import { Card, CardContent, Grid, Typography, Box, Divider } from '@mui/material';
import { DateFormats } from '@uplift/constants';
import { useL10n } from '@uplift/hooks';
import { CalendarDateService, DateObject } from '@uplift/services';
import { useStyles } from './styles';
import { PublicAppointment } from '@uplift/api';


export type AppointmentCardProps = {
  nextAppointment?: PublicAppointment;
  lastAppointment?: PublicAppointment;
};

const formatAppointmentTime = (appt: DateObject) =>
  appt.minute() > 0
    ? appt.format('dddd h:m a z')
    : appt.format('dddd h a z');

const renderNextAppointment = (nextAppointment: PublicAppointment) => {
  if (!nextAppointment || nextAppointment.state === 'cancelled') {
    return (
      <Grid size="grow">–
      </Grid>
    );
  } else {
    const next = CalendarDateService.date.utc(nextAppointment.fromDatetime).tz(nextAppointment.timezone);

    return (
      <Grid container size="grow" alignItems="center" gap={0}>
        {next.format(DateFormats['DEFAULT_DATE'])}<br />
        <Typography variant="body2">
          {formatAppointmentTime(next)}
        </Typography>
      </Grid>
    );
  }
};

export const AppointmentCard: React.VFC<AppointmentCardProps> = props => {
  const l10n = useL10n();
  const { classes } = useStyles();

  const lastAppointment = props.lastAppointment
    ? CalendarDateService.date.utc(props.lastAppointment.fromDatetime).tz(props.lastAppointment.timezone)
    : undefined;

  return (
    <Card>
      <CardContent>
        <Grid container spacing={2} direction="column">
          <Grid>
            <Typography variant="body1" className={classes.title}>
              {l10n.clientProfile.psychiatry.visits.visitSummary}
            </Typography>
          </Grid>
          {props.nextAppointment && (
            <Grid container>
              <Grid container alignItems="center" size="grow">
                <Typography variant="body2" className={classes.visitTitle}>
                  {l10n.clientProfile.psychiatry.visits.nextVisit}
                </Typography>
              </Grid>
              {renderNextAppointment(props.nextAppointment)}
            </Grid>
          )}
          {props.nextAppointment && props.lastAppointment && (
            <Box display="flex" width="100%" my={1}>
              <Divider style={{ width: '100%' }} />
            </Box>
          )}
          {props.lastAppointment && (
            <Grid container>
              <Grid container alignItems="center" size="grow">
                <Typography variant="body2" className={classes.visitTitle}>
                  {l10n.clientProfile.psychiatry.visits.lastVisit}
                </Typography>
              </Grid>
              <Grid size="grow">
                {lastAppointment.format(DateFormats['DEFAULT_DATE'])}<br />
                <Typography variant="body2">
                  {formatAppointmentTime(lastAppointment)}
                </Typography>
              </Grid>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};
